import { render, staticRenderFns } from "./CategoriesList.vue?vue&type=template&id=473796fa&scoped=true"
import script from "./CategoriesList.vue?vue&type=script&lang=js"
export * from "./CategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473796fa",
  null
  
)

export default component.exports